<div class="tooltip-arrow" *ngIf="isArrow"></div>

<ng-template ad-host></ng-template>